import { render, staticRenderFns } from "./DivB.vue?vue&type=template&id=790ceb7a&scoped=true"
import script from "./DivB.vue?vue&type=script&lang=js"
export * from "./DivB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ceb7a",
  null
  
)

export default component.exports